import { EStatus } from './enums'

export const BOTTOM_NAVBAR_HEIGHT = 72

export const STATUS_COLOR: Record<EStatus, string> = {
  [EStatus.PENDING]: 'yellow',
  [EStatus.RELEASED]: 'green',
  [EStatus.COMPLETED]: 'green'
}
